import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'on-external-signin-error-page',
    templateUrl: './external-signin-error-page.component.html',
    styleUrls: ['./external-signin-error-page.component.scss'],
})
export class ExternalSigninErrorPageComponent implements OnInit {
    constructor() {}

    ngOnInit(): void {}
}
